// extracted by mini-css-extract-plugin
export default {"SeverityDot":"index__SeverityDot__iDZW3","high":"index__high__NaIFs","medium":"index__medium__ThCYa","low":"index__low__m6tHj"};